var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEligibleInstitutes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.073,
    height: 81.53,
    viewBox: "0 0 140.073 81.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.064 27.739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.241,
    height: 7.112,
    rx: 3.556,
    fill: "#d92d65"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 7.112,
    transform: "translate(2.665)",
    fill: "#a50f45"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 7.112,
    fill: "#a50f45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 7.112,
    transform: "translate(2.665)",
    fill: "#a50f45"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 7.112,
    fill: "#a50f45"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 26.487,
    height: 2.322,
    transform: "translate(14.468 1.942)",
    fill: "#a50f45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.064 21.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.82,
    height: 6.184,
    rx: 3.092,
    fill: "#fcc447"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.099)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 6.184,
    transform: "translate(2.665)",
    fill: "#e0a122"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 6.184,
    fill: "#e0a122"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 6.184,
    transform: "translate(2.665)",
    fill: "#e0a122"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.599,
    height: 6.184,
    fill: "#e0a122"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 19.066,
    height: 1.395,
    transform: "translate(14.468 1.942)",
    fill: "#e0a122"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.073,249.457a2.6,2.6,0,0,1-2.6,2.6H2.6a2.6,2.6,0,0,1-2.6-2.6H0a2.6,2.6,0,0,1,2.6-2.6H137.476a2.6,2.6,0,0,1,2.6,2.6Z",
    transform: "translate(0 -170.525)",
    fill: "#daefeb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.928 34.848)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.127,128.3a5.771,5.771,0,0,1-3.615-5.334v-.544a5.771,5.771,0,0,1,3.615-5.334v-.421H253.764a5.771,5.771,0,0,0-5.754,5.751v.544a5.772,5.772,0,0,0,5.754,5.754h37.362V128.3Z",
    transform: "translate(-241.251 -116.67)",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.16)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    transform: "translate(0 1.855)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    transform: "translate(0 3.711)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    transform: "translate(0 5.566)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    transform: "translate(0 7.421)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.46,
    height: 0.618,
    transform: "translate(0 9.276)",
    fill: "#e4ebf2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M288.377,125.553v-.813H251.015a4.526,4.526,0,0,1-4.521-4.521v-.544a4.526,4.526,0,0,1,4.521-4.521h37.362V112.69H251.015a6.993,6.993,0,0,0-6.985,6.985v.544a6.991,6.991,0,0,0,6.985,6.985h37.362Z",
    transform: "translate(-238.501 -112.69)",
    fill: "#fcc447"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.428 49.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.217,
    height: 12.375,
    rx: 6.187,
    fill: "#08d0c5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.671)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.783,
    height: 12.375,
    transform: "translate(4.638)",
    fill: "#11998f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.783,
    height: 12.375,
    fill: "#11998f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.783,
    height: 12.375,
    transform: "translate(4.638)",
    fill: "#11998f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.783,
    height: 12.375,
    fill: "#11998f"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.71 61.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.5,204.067a5.771,5.771,0,0,1,3.615,5.334v.544a5.771,5.771,0,0,1-3.615,5.334v.421h49.731a5.769,5.769,0,0,0,5.751-5.754V209.4a5.768,5.768,0,0,0-5.751-5.751H243.5v.42Z",
    transform: "translate(-234.916 -203.65)",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.996)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    transform: "translate(0 9.276)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    transform: "translate(0 7.421)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    transform: "translate(0 5.566)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    transform: "translate(0 3.711)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    transform: "translate(0 1.855)",
    fill: "#e4ebf2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.828,
    height: 0.618,
    fill: "#e4ebf2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M243.5,201.311v.813h49.731a4.526,4.526,0,0,1,4.521,4.521v.544a4.526,4.526,0,0,1-4.521,4.521H243.5v2.464h49.731a6.993,6.993,0,0,0,6.985-6.985v-.544a6.992,6.992,0,0,0-6.985-6.985H243.5Z",
    transform: "translate(-234.916 -199.66)",
    fill: "#d1396c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.064 4.022)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.087,21.677a.529.529,0,0,1-.529.529h0a.529.529,0,0,1-.529-.529V13.529a.529.529,0,0,1,.529-.529h0a.529.529,0,0,1,.529.529Z",
    transform: "translate(-134.03 -13)",
    fill: "#c7cff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25,20.426h-3.8v-3.9h3.8l-1.119,1.948Z",
    transform: "translate(-136.392 -15.438)",
    fill: "#d9ddf9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.046)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.545,
    height: 41.475,
    transform: "translate(1.636 5.881)",
    fill: "#d9ddf9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 67.813,
    height: 5.884,
    transform: "translate(0 47.359)",
    fill: "#bbc5ea"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.813,
    height: 5.884,
    fill: "#bbc5ea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.735 5.881)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 5.232,
    height: 41.475,
    transform: "translate(1.169)",
    fill: "#c5ccef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73,95.494a.8.8,0,0,1-.8.8H38.964a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-38.16 -94.69)",
    fill: "#9cace5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73,224.441a.8.8,0,0,1-.8.8H38.964a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-38.16 -183.767)",
    fill: "#9cace5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.232,
    height: 41.475,
    transform: "translate(1.169)",
    fill: "#c5ccef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.98,95.494a.8.8,0,0,1-.8.8H75.214a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-74.41 -94.69)",
    fill: "#9cace5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.98,224.441a.8.8,0,0,1-.8.8H75.214a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-74.41 -183.767)",
    fill: "#9cace5"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.564)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 5.232,
    height: 41.475,
    transform: "translate(1.172)",
    fill: "#c5ccef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,95.494a.8.8,0,0,1-.8.8h-5.962a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-172.58 -94.69)",
    fill: "#9cace5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,224.441a.8.8,0,0,1-.8.8h-5.962a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8h5.962a.8.8,0,0,1,.8.8Z",
    transform: "translate(-172.58 -183.767)",
    fill: "#9cace5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.232,
    height: 41.475,
    transform: "translate(1.172)",
    fill: "#c5ccef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,95.494a.8.8,0,0,1-.8.8h-5.962a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8H215.6a.8.8,0,0,1,.8.8Z",
    transform: "translate(-208.83 -94.69)",
    fill: "#9cace5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,224.441a.8.8,0,0,1-.8.8h-5.962a.8.8,0,0,1-.8-.8h0a.8.8,0,0,1,.8-.8H215.6a.8.8,0,0,1,.8.8Z",
    transform: "translate(-208.83 -183.767)",
    fill: "#9cace5"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M127.094,176.362V159.887a7.007,7.007,0,0,0-14.014,0v16.475h14.01Z",
    transform: "translate(-86.178 -129.006)",
    fill: "#c5ccef"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.643,39.02,31.37,50.353H95.915Z",
    transform: "translate(-29.734 -39.02)",
    fill: "#c7cff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.472,43.55,57.18,52.081h48.587Z",
    transform: "translate(-47.563 -42.149)",
    fill: "#d9ddf9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.453 43.888)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.658,
    height: 21.008,
    transform: "translate(6.52 11.553)",
    fill: "#4557db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.078,164.367s1.147-.411,2.548-.9l30.773-10.73c1.4-.489,1.367-1.215-.08-1.614l-30.612-8.451c-1.447-.4-2.628-.73-2.628-.736s-.009-.009-.019-.006h-.037c-.009,0-.019,0-.019.006s-1.184.337-2.628.736l-30.612,8.451c-1.447.4-1.481,1.126-.08,1.614l30.77,10.73c1.4.489,2.548.894,2.548.9s.009.009.019.006a.075.075,0,0,1,.037,0c.009,0,.019,0,.019-.006Z",
    transform: "translate(-114.655 -141.926)",
    fill: "#7b85ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.115,173.259c0,.739-1.314,1.339-2.938,1.339s-2.937-.6-2.937-1.339,1.314-1.339,2.937-1.339S222.115,172.52,222.115,173.259Z",
    transform: "translate(-184.829 -162.646)",
    fill: "#fcc447"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.976 10.227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.107,175.612l-32.2-.612a.387.387,0,0,0,0,.773q15.909.3,31.815.606v12.2a.387.387,0,0,0,.773,0V176a.391.391,0,0,0-.387-.387Z",
    transform: "translate(-224.533 -175)",
    fill: "#fcc447"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.019 11.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.067,212.269a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,328.067,212.269Z",
    transform: "translate(-323.863 -210.67)",
    fill: "#fcc447"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.526,216.058q-.951,3.391-1.9,6.781a.194.194,0,0,0,.374.1q.58-2.055,1.156-4.113l-.575,4.23c-.034.244.34.349.371.1q.478-3.5.952-7C323.934,215.922,323.6,215.811,323.526,216.058Z",
    transform: "translate(-321.613 -215.919)",
    fill: "#fcc447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.551,222.839q-.951-3.39-1.9-6.781c-.068-.247-.405-.136-.374.1a.108.108,0,0,0,0,.031.192.192,0,0,0-.346.108q-.329,3.4-.662,6.812c-.025.247.362.247.387,0q.223-2.277.442-4.558.162,2.2.328,4.4c.019.247.405.247.387,0l-.464-6.243q.441,3.224.878,6.447c.034.247.405.142.371-.1l-.575-4.23q.58,2.055,1.156,4.113a.194.194,0,0,0,.374-.1Z",
    transform: "translate(-325.518 -215.919)",
    fill: "#fcc447"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.724 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.465.449a10.923,10.923,0,1,1-13.584,7.356A10.923,10.923,0,0,1,252.465.449Z",
    transform: "translate(-238.426 0.008)",
    fill: "#7b85ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,6.94a8.894,8.894,0,1,1-11.061,5.989A8.893,8.893,0,0,1,256.42,6.94Z",
    transform: "translate(-242.959 -4.535)",
    fill: "#c8ede6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.019,
    height: 14.236,
    transform: "translate(19.7 14.593) rotate(-73.44)",
    fill: "#7b85ff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 4.669,
    height: 17.424,
    transform: "translate(23.273 17.035) rotate(-73.44)",
    fill: "#d1396c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.954,18.538a6.917,6.917,0,0,1,8.479-4.592c.473.127.693-.6.216-.73a7.694,7.694,0,0,0-9.425,5.105.381.381,0,0,0,.73.216h0Z",
    transform: "translate(-247.943 -8.934)",
    fill: "#fdfeff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibleInstitutes);
export default __webpack_public_path__ + "static/media/eligible-institutes.73b1331780e5517b5947193f077f2527.svg";
export { ForwardRef as ReactComponent };